import { render, staticRenderFns } from "./competition-2.vue?vue&type=template&id=2985ebcc&scoped=true&"
import script from "./competition-2.vue?vue&type=script&lang=js&"
export * from "./competition-2.vue?vue&type=script&lang=js&"
import style0 from "./competition-2.vue?vue&type=style&index=0&id=2985ebcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985ebcc",
  null
  
)

export default component.exports